import { render, staticRenderFns } from "./FaskesSetting.vue?vue&type=template&id=29529ed0&scoped=true&"
import script from "./FaskesSetting.vue?vue&type=script&lang=js&"
export * from "./FaskesSetting.vue?vue&type=script&lang=js&"
import style0 from "./FaskesSetting.vue?vue&type=style&index=0&id=29529ed0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29529ed0",
  null
  
)

export default component.exports